import React from 'react';
import timeAgo from 'shared/time-ago';
import {AdminChangedListing, AdminCollegeListing} from 'src/services/AdminCollegeListingService';
import styles from './styles.module.scss';

interface ListingTableProps {
  listings: AdminCollegeListing[] | AdminChangedListing[];
  lastUniId?: string;
  title: string;
  nonPartners?: boolean;
  partnersEditable: boolean;
  searchQuery?: string;
}

export default function ListingTable(props: ListingTableProps) {
  const {searchQuery = ''} = props;
  const query = searchQuery.trim().toLowerCase();

  const filteredListings = query
    ? props.listings.filter((entry) => {
        const listing = Array.isArray(entry) ? entry[0] : entry;
        return (
          listing.name.toLowerCase().includes(query) ||
          listing.slug.toLowerCase().includes(query) ||
          listing.school_stabbr?.toLowerCase().includes(query) ||
          listing.nickname?.toLowerCase().includes(query)
        );
      })
    : props.listings;

  const hiddenCount = props.listings.length - filteredListings.length;

  return (
    <>
      <h2>{props.title}</h2>
      {filteredListings.length === 0 && hiddenCount > 0 && (
        <p className={styles.hiddenCount}>
          {hiddenCount} item{hiddenCount !== 1 ? 's' : ''} hidden by filter
        </p>
      )}
      {filteredListings.length > 0 && (
        <>
          {hiddenCount > 0 && (
            <p className={styles.hiddenCount}>
              {hiddenCount} item{hiddenCount !== 1 ? 's' : ''} hidden by filter
            </p>
          )}
          <table className="college-listings-table table-striped">
            <tbody>
              {filteredListings.map((entry, i) => {
                const listing = Array.isArray(entry) ? entry[0] : entry;
                const change = Array.isArray(entry) ? entry[1] : null;
                const isLastUniId = props.lastUniId && listing.university_id === props.lastUniId;

                return (
                  <tr
                    key={i}
                    style={{
                      backgroundColor: isLastUniId ? '#deffeb' : '',
                    }}
                  >
                    <td style={{padding: '6px'}}>
                      {isLastUniId && '🆕'} {listing.name}{' '}
                      {listing.nickname && `(${listing.nickname})`} ({listing.school_stabbr}){' '}
                      {isLastUniId && '🆕'}
                    </td>
                    {change && (
                      <td>
                        Last edited {timeAgo(change.updated_at)} by {change.editor_email}
                      </td>
                    )}
                    <td>
                      <a href={`/admin/college_listings/${listing.slug}/edit`}>Edit Profile</a>
                    </td>
                    {!props.nonPartners && (
                      <td>
                        <a href={`/admin/university/edit?id=${listing.university_id}`}>
                          Edit Partner
                        </a>
                      </td>
                    )}
                    {props.nonPartners ? (
                      props.partnersEditable && (
                        <td>
                          <a href={`/admin/university/new?slug=${listing.slug}`}>Add as Partner</a>
                        </td>
                      )
                    ) : (
                      <td>
                        <a href={`/admin/university/${listing.university_id}/scholarship_programs`}>
                          Edit Scholarship Programs
                        </a>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}
    </>
  );
}
